module.exports = __webpack_public_path__ + "static/media/my.25f0898c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/my.svg
// module id = 2168
// module chunks = 0